/* Lakewood "fits your truck" layer.
   1. Keeps the header truck (lakewood:selected-vehicle:v1) and the Convermax
      truck in sync, so "Shopping for ..." always matches what the results use.
   2. On collection pages, when a truck is selected, replaces the browse view
      with the parts made for that truck followed by universal-fit parts.
      Category pages show one card per product line ("See 10 options" opens
      the line); product-line pages show every fitting version as its own
      image card. Falls back to the normal page when a category has nothing
      vehicle-specific. */
(function () {
  'use strict';

  var KEY = 'lakewood:selected-vehicle:v1';
  var CM_LAST = 'lakewood:cm-last-vehicle';
  var API = 'https://gitiuy-fk.myconvermax.com/search.json';
  var html = document.documentElement;

  function ls(get, k, v) {
    try {
      if (get) return window.localStorage.getItem(k);
      if (v === null) window.localStorage.removeItem(k);
      else window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function saved() {
    try {
      var v = JSON.parse(ls(true, KEY) || 'null');
      return v && v.year && v.make && v.model ? v : null;
    } catch (e) { return null; }
  }
  function vstr(v) { return v ? [v.year, v.make, v.model, v.submodel || ''].join('|').toLowerCase() : ''; }
  function label(v) { return v ? [v.year, v.make, v.model, v.submodel].filter(Boolean).join(' ') : ''; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) {
    n = Number(n);
    if (!isFinite(n)) return '';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function img(u, w) {
    if (!u) return '';
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u)) return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 600);
    return u;
  }
  function plural(n, one, many) { return n === 1 ? one : many; }

  /* ---------------- vehicle sync ---------------- */
  function cm() { return window.Convermax && typeof window.Convermax.getVehicle === 'function' ? window.Convermax : null; }
  function cmVehicle() {
    var C = cm();
    if (!C) return null;
    try {
      var v = C.getVehicle();
      return v && v.Year && v.Make && v.Model ? { year: String(v.Year), make: v.Make, model: v.Model, submodel: v.Submodel || '' } : null;
    } catch (e) { return null; }
  }
  function saveLw(v) {
    ls(false, KEY, v ? JSON.stringify(v) : null);
    document.dispatchEvent(new CustomEvent('lakewood:vehiclechange', { detail: v }));
  }
  function pushToCm(v) {
    var C = cm();
    if (!C || !v) return;
    try { C.setVehicle({ Year: v.year, Make: v.make, Model: v.model, Submodel: v.submodel || '' }); } catch (e) {}
  }
  var syncing = false;
  function sync() {
    if (!cm()) return;
    syncing = true;
    var c = cmVehicle(), l = saved(), last = ls(true, CM_LAST) || '';
    if (c) {
      if (vstr(c) !== vstr(l)) saveLw(c);           // Convermax is what filters results: it wins
      ls(false, CM_LAST, vstr(c));
    } else if (last && l) {                          // the shopper cleared the Convermax truck
      ls(false, CM_LAST, '');
      saveLw(null);
    } else if (l) {                                  // truck chosen in our own selector
      pushToCm(l);
      ls(false, CM_LAST, vstr(l));
    }
    syncing = false;
  }
  document.addEventListener('lakewood:vehiclechange', function (e) {
    if (syncing) return;
    var l = saved(), c = cmVehicle();
    if (l && vstr(l) !== vstr(c)) { pushToCm(l); ls(false, CM_LAST, vstr(l)); }
  });

  function whenCm(cb) {
    var n = 0;
    (function tick() {
      if (cm()) return cb();
      if (n++ < 50) return setTimeout(tick, 120);
      cb();
    })();
  }

  var lastSeen = null;
  function watch() {
    setInterval(function () {
      var s = vstr(cmVehicle());
      if (lastSeen !== null && s !== lastSeen) sync();
      lastSeen = s;
    }, 1200);
  }

  /* ---------------- fitted results ---------------- */
  var root, state = { vsPage: 0, uPage: 0, token: 0 };

  function vehicleParams(v, start) {
    var i = start, p = '';
    [['Year', v.year], ['Make', v.make], ['Model', v.model], ['Submodel', v.submodel]].forEach(function (f) {
      if (!f[1]) return;
      p += '&facet.' + i + '.field=' + f[0] + '&facet.' + i + '.selection=' + encodeURIComponent(f[1]);
      i++;
    });
    return { q: p, next: i };
  }
  function search(opts) {
    var p = API + '?pagesize=' + (opts.size || 24) + (opts.page ? '&page=' + opts.page : '');
    if (opts.query) p += '&query=' + encodeURIComponent(opts.query);
    var i = 0;
    if (opts.collection) { p += '&facet.0.field=collection_ids&facet.0.selection=' + opts.collection; i = 1; }
    if (opts.vehicle) { var vp = vehicleParams(opts.vehicle, i); p += vp.q; i = vp.next; }
    (opts.fitment || []).forEach(function (ft) {
      p += '&facet.' + i + '.field=FitmentType&facet.' + i + '.selection=' + encodeURIComponent(ft);
    });
    if (opts.fitment && opts.fitment.length) i++;
    p += '&extra.country=us&extra.currency=usd';
    return fetch(p, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('search ' + r.status);
      return r.json();
    }).then(function (d) {
      /* keyword searches come back with <b> highlight tags in the titles */
      (d.Items || []).forEach(function (it) { it.title = String(it.title || '').replace(/<[^>]*>/g, ''); });
      return d;
    });
  }
  function facetCounts(res, field) {
    var out = {};
    (res.Facets || []).forEach(function (f) {
      if (f.FieldName === field) (f.Values || []).forEach(function (v) { out[v.Value] = v.HitCount || 0; });
    });
    return out;
  }

  function lineMap() {
    var el = root.querySelector('[data-lw-lines]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }
  function lineOf(item, lines) {
    var cats = item.category || [];
    for (var i = 0; i < cats.length; i++) if (lines[cats[i]]) return lines[cats[i]];
    return null;
  }
  /* The bits that tell one version of a line apart from the rest ("Rear", "Tan", "With Bench Seating").
     Part numbers are dropped: the card shows the SKU on its own. */
  function isPartNo(bit, sku) {
    var b = String(bit).replace(/^(part|p\/n|pn|#)\s*#?\s*/i, '').trim();
    if (!b) return true;
    var bl = b.toLowerCase(), sl = String(sku || '').toLowerCase();
    if (sl && b.length >= 4 && (sl === bl || sl.indexOf(bl) > -1 || bl.indexOf(sl) > -1)) return true;
    return /^[A-Z0-9][A-Z0-9.\-\/]{3,}$/i.test(b) && /\d/.test(b);
  }
  function specBits(title, sku) {
    var S = window.LakewoodCoverSpecs, bits = [];
    if (S && S.parseTitle) {
      var s = S.parseTitle(title);
      if (s.bed) bits.push(s.bed + ' bed');
      (s.features || []).forEach(function (f) { bits.push(f); });
      (s.quals || []).forEach(function (q) { bits.push(q.label); });
    }
    if (!bits.length) bits = title.split(/\s+-\s+/).slice(1);
    return bits.filter(function (b) { return !isPartNo(b, sku); });
  }
  function specText(title, sku) {
    var bits = specBits(title, sku);
    return bits.length ? bits.join(' · ') : title;
  }

  /* Colors: floor liners and cargo liners are one product per color ("... - Rear - Tan - ...").
     Versions that differ only by color share one card with a color picker. */
  var COLOR_RE = /^(black|tan|gr[ae]y|cocoa|brown|beige|charcoal|red|blue|white|silver)$/i;
  var COLOR_HEX = { black: '#151515', tan: '#c9b48c', gray: '#8c8c8c', grey: '#8c8c8c', cocoa: '#5a3a2a', brown: '#6b4a2b', beige: '#d9cbaa', charcoal: '#454545', red: '#c62828', blue: '#1f4e9c', white: '#f4f4f4', silver: '#c0c0c0' };
  function colorSplit(bits) {
    var color = '', rest = [];
    bits.forEach(function (b) {
      if (!color && COLOR_RE.test(b)) color = b.charAt(0).toUpperCase() + b.slice(1).toLowerCase();
      else rest.push(b);
    });
    return { color: color, rest: rest };
  }
  /* "1st Row" / "2nd Seat Floor Liner" -> "Front floor liners" / "Rear floor liners", so cards read by row. */
  var POS_ORDER = { 'Front': 0, 'Front & rear': 1, 'Rear': 2, '3rd row': 3 };
  function positionLabel(rest, title) {
    if (!rest.length) return '';
    var kind = /\bfloor/i.test(title) ? (/liner/i.test(title) ? 'floor liners' : 'floor mats') : '';
    var pos = null, others = [], m;
    rest.forEach(function (b) {
      if (pos !== null) { others.push(b); return; }
      if ((m = b.match(/^(?:front|1st|first)\s*(?:&|and)\s*(?:2nd|second|rear)\s*(?:row|seat)?(?:\s+floor)?(?:\s+(?:liners?|mats?))?\s*(\(.*\))?$/i))) pos = 'Front & rear';
      else if ((m = b.match(/^(?:1st row|first row|front)(?:\s+floor)?(?:\s+(?:liners?|mats?))?\s*(\(.*\))?$/i))) pos = 'Front';
      else if ((m = b.match(/^(?:(?:2nd|second)\s+(?:row|seat)|rear)(?:\s+floor)?(?:\s+(?:liners?|mats?))?\s*(\(.*\))?$/i))) pos = 'Rear';
      else if ((m = b.match(/^(?:3rd|third)\s+(?:row|seat)(?:\s+floor)?(?:\s+(?:liners?|mats?))?\s*(\(.*\))?$/i))) pos = '3rd row';
      else { others.push(b); return; }
      var extra = (m[1] || '').replace(/^\(|\)$/g, '').trim();
      if (extra) others.push(extra);
    });
    if (pos === null) return rest.join(' · ');
    return pos + (kind ? ' ' + kind : '') + (others.length ? ' · ' + others.join(' · ') : '');
  }
  function posRank(label) {
    var head = String(label).split(' · ')[0].replace(/ floor (?:liners|mats)$/, '');
    return POS_ORDER[head] === undefined ? 9 : POS_ORDER[head];
  }
  /* Group a line's versions: one entry per row/size; entries with several colors get a color picker. */
  function groupOptions(items) {
    var groups = [], byKey = {};
    items.forEach(function (it, i) {
      var bits = specBits(it.title, it.sku), cs = colorSplit(bits);
      var label = positionLabel(cs.rest, it.title);
      var key = cs.color ? 'c:' + cs.rest.join('|').toLowerCase() : 's:' + i;
      if (!byKey[key]) { byKey[key] = { key: key, label: label, rest: cs.rest, items: [], colors: [], order: i }; groups.push(byKey[key]); }
      byKey[key].items.push(it);
      byKey[key].colors.push(cs.color);
    });
    groups.forEach(function (g) {
      /* two of the same color that both fit (rare): tell them apart by part number */
      var seen = {};
      g.colors = g.colors.map(function (c, i) { if (!c) return c; var k = c.toLowerCase(); if (seen[k] && g.items[i].sku) c = c + ' · #' + g.items[i].sku; seen[k] = true; return c; });
    });
    return groups.sort(function (a, b) { return posRank(a.label) - posRank(b.label) || a.order - b.order; });
  }
  function brandName(v) {
    return ({ 'Gatorback by Truck Hardware': 'Gatorback', 'RealTruck AMP Research': 'AMP Research', 'RealTruck BackRack': 'BackRack',
      'B&W Trailer Hitches': 'B&W', 'BAK Industries': 'BAK' })[v] || v || '';
  }

  /* ---------------- cards ---------------- */
  function badgeHtml(text, muted) {
    return '<div class="lw-product-card__badges"><span class="lw-product-card__badge' + (muted ? ' is-muted' : '') + '">' + esc(text) + '</span></div>';
  }
  function imgHtml(u, alt) {
    return u ? '<img class="lw-product-card__image lw-product-card__image--primary" loading="lazy" src="' + esc(img(u, 600)) + '" alt="' + esc(alt) + '">' : '';
  }
  function minPrice(items) {
    var prices = items.map(function (i) { return Number(i.price); }).filter(isFinite);
    return prices.length ? Math.min.apply(null, prices) : null;
  }
  function heroImage(items) {
    for (var i = 0; i < items.length; i++) if (items[i].image) return items[i].image;
    return '';
  }

  /* A single part that fits (or a universal part). */
  function productCard(it, badge) {
    return '<article class="lw-product-card lw-product-card--next lw-fit-card">' +
      '<a class="lw-product-card__link" href="' + esc(it.url) + '">' +
      '<div class="lw-product-image">' + badgeHtml(badge, badge === 'Universal fit') + imgHtml(it.image, it.title) + '</div>' +
      '<div class="lw-product-info"><div class="lw-product-card__topline"><span class="lw-product-brand">' + esc(brandName(it.vendor)) + '</span>' +
      (it.sku ? '<span class="lw-product-card__sku">#' + esc(it.sku) + '</span>' : '') + '</div>' +
      '<h3 class="lw-product-title">' + esc(it.title) + '</h3>' +
      '<div class="lw-product-card__meta"><strong class="lw-product-price">' + money(it.price) + '</strong></div>' +
      '<div class="lw-product-actions"><span class="lw-btn">View product <span aria-hidden="true">&rarr;</span></span></div>' +
      '</div></a></article>';
  }

  /* One version of a product line, shown with its own image. */
  function optionCard(it, optLabel) {
    var showLabel = optLabel && optLabel !== it.title;
    return '<article class="lw-product-card lw-product-card--next lw-fit-card lw-fit-option">' +
      '<a class="lw-product-card__link" href="' + esc(it.url) + '">' +
      '<div class="lw-product-image">' + badgeHtml('Fits your truck') + imgHtml(it.image, it.title) + '</div>' +
      '<div class="lw-product-info"><div class="lw-product-card__topline"><span class="lw-product-brand">' + esc(brandName(it.vendor)) + '</span>' +
      (it.sku ? '<span class="lw-fit-sku">#' + esc(it.sku) + '</span>' : '') + '</div>' +
      (showLabel
        ? '<h3 class="lw-product-title lw-fit-option__label">' + esc(optLabel) + '</h3><p class="lw-fit-option__name">' + esc(it.title) + '</p>'
        : '<h3 class="lw-product-title">' + esc(it.title) + '</h3>') +
      '<div class="lw-product-card__meta"><strong class="lw-product-price">' + money(it.price) + '</strong></div>' +
      '<div class="lw-product-actions"><span class="lw-btn">View product <span aria-hidden="true">&rarr;</span></span></div>' +
      '</div></a></article>';
  }

  /* Versions that differ only by color: one card, pick the color, the picture and price follow. */
  var colorGroups = [];
  function colorCard(g) {
    var idx = colorGroups.length; colorGroups.push(g);
    var sel = 0;
    g.colors.forEach(function (c, i) { if (c === 'Black') sel = i; });
    var it = g.items[sel];
    var S = window.LakewoodCoverSpecs;
    var heading = g.label || (S && S.parseTitle ? S.parseTitle(it.title).line : '') || it.title;
    var swatches = g.items.map(function (x, i) {
      var c = g.colors[i], hex = COLOR_HEX[c.split(' ')[0].toLowerCase()] || '#999';
      return '<span class="lw-fit-swatch' + (i === sel ? ' is-selected' : '') + '" role="button" tabindex="0" data-fit-color="' + i + '" aria-pressed="' + (i === sel ? 'true' : 'false') + '"><i style="background:' + hex + '"></i>' + esc(c) + '</span>';
    }).join('');
    return '<article class="lw-product-card lw-product-card--next lw-fit-card lw-fit-option lw-fit-cg" data-fit-cg="' + idx + '">' +
      '<a class="lw-product-card__link" href="' + esc(it.url) + '" data-cg-link>' +
      '<div class="lw-product-image">' + badgeHtml('Fits your truck') + imgHtml(it.image, it.title) + '</div>' +
      '<div class="lw-product-info"><div class="lw-product-card__topline"><span class="lw-product-brand">' + esc(brandName(it.vendor)) + '</span>' +
      '<span class="lw-fit-sku" data-cg-sku>' + (it.sku ? '#' + esc(it.sku) : '') + '</span></div>' +
      '<h3 class="lw-product-title lw-fit-option__label">' + esc(heading) + '</h3>' +
      '<p class="lw-fit-option__name" data-cg-name>' + esc(it.title) + '</p>' +
      '<div class="lw-fit-colors"><span class="lw-fit-colors__label">Color: <strong data-cg-color>' + esc(g.colors[sel]) + '</strong></span>' +
      '<div class="lw-fit-swatches">' + swatches + '</div></div>' +
      '<div class="lw-product-card__meta"><strong class="lw-product-price" data-cg-price>' + money(it.price) + '</strong></div>' +
      '<div class="lw-product-actions"><span class="lw-btn">View product <span aria-hidden="true">&rarr;</span></span></div>' +
      '</div></a></article>';
  }
  function selectColor(card, i) {
    var g = colorGroups[Number(card.getAttribute('data-fit-cg'))];
    if (!g || !g.items[i]) return;
    var it = g.items[i];
    var link = card.querySelector('[data-cg-link]');
    if (link) link.setAttribute('href', it.url);
    var wrap = card.querySelector('.lw-product-image'), im = wrap && wrap.querySelector('.lw-product-card__image');
    if (wrap) {
      if (it.image) {
        if (!im) { wrap.insertAdjacentHTML('beforeend', imgHtml(it.image, it.title)); }
        else { im.src = img(it.image, 600); im.alt = it.title; }
      } else if (im) im.remove();
    }
    var set = function (sel, text) { var n = card.querySelector(sel); if (n) n.textContent = text; };
    set('[data-cg-sku]', it.sku ? '#' + it.sku : '');
    set('[data-cg-name]', it.title);
    set('[data-cg-color]', g.colors[i]);
    set('[data-cg-price]', money(it.price));
    card.querySelectorAll('[data-fit-color]').forEach(function (sw) {
      var on = sw.getAttribute('data-fit-color') === String(i);
      sw.classList.toggle('is-selected', on);
      sw.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  /* A line's versions for the truck: one card per row/size, colors picked on the card. */
  function renderOptions(items) {
    return groupOptions(items).map(function (g) {
      if (g.items.length > 1 && g.colors[0]) return colorCard(g);
      var it = g.items[0];
      var lbl = g.label ? g.label + (g.colors[0] ? ' · ' + g.colors[0] : '') : specText(it.title, it.sku);
      return optionCard(it, lbl);
    }).join('');
  }

  /* Category page: one card per product line. Opening it shows every version for the truck. */
  function lineSummary(items) {
    var groups = groupOptions(items), colors = 0;
    groups.forEach(function (g) { var n = g.colors.filter(Boolean).length; if (n > colors) colors = n; });
    return { n: groups.length, colors: colors };
  }
  function lineCardInner(line, items, v, cta) {
    var min = minPrice(items), sm = lineSummary(items), n = sm.n;
    return '<div class="lw-product-image">' + badgeHtml('Fits your truck') + imgHtml(heroImage(items), line.title) + '</div>' +
      '<div class="lw-product-info"><div class="lw-product-card__topline"><span class="lw-product-brand">' + esc(brandName(items[0].vendor)) + '</span></div>' +
      '<h3 class="lw-product-title">' + esc(line.title) + '</h3>' +
      '<p class="lw-fit-line__count"><strong>' + n + ' ' + plural(n, 'option', 'options') + '</strong> for your ' + esc(label(v)) + (sm.colors > 1 ? ' &middot; ' + sm.colors + ' colors' : '') + '</p>' +
      (min !== null ? '<div class="lw-product-card__meta"><span>From</span> <strong class="lw-product-price">' + money(min) + '</strong></div>' : '') +
      '<div class="lw-product-actions"><span class="lw-btn">' + cta + '</span></div></div>';
  }
  function lineCard(line, items, v) {
    var n = lineSummary(items).n;
    var href = line.url + (line.url.indexOf('?') > -1 ? '&' : '?') + 'fit=1';
    return '<article class="lw-product-card lw-product-card--next lw-fit-card lw-line-card">' +
      '<a class="lw-product-card__link" href="' + esc(href) + '">' +
      lineCardInner(line, items, v, 'See ' + n + ' ' + plural(n, 'option', 'options') + ' <span aria-hidden="true">&rarr;</span>') +
      '</a></article>';
  }
  /* A family the search index has no product-line page for: the card opens its versions in place. */
  function familyCard(line, items, v, idx) {
    var n = lineSummary(items).n;
    return '<article class="lw-product-card lw-product-card--next lw-fit-card lw-line-card">' +
      '<a class="lw-product-card__link" href="#lw-fit-panel-' + idx + '" role="button" data-fit-expand="' + idx + '" aria-expanded="false" aria-controls="lw-fit-panel-' + idx + '">' +
      lineCardInner(line, items, v, 'See ' + n + ' ' + plural(n, 'option', 'options') + ' <span aria-hidden="true">&#9662;</span>') +
      '</a></article>';
  }
  function familyPanel(line, items, v, idx) {
    return '<div class="lw-fit-family" id="lw-fit-panel-' + idx + '" data-fit-panel="' + idx + '" hidden>' +
      '<div class="lw-fit-family__head"><div><span class="lw-kicker">' + esc(brandName(items[0].vendor)) + '</span><h3>' + esc(line.title) + '</h3>' +
      '<p>' + items.length + ' ' + plural(items.length, 'version fits', 'versions fit') + ' your ' + esc(label(v)) + '. Pick the one that matches your truck.</p></div>' +
      '<a href="#" class="lw-fit__link" data-fit-collapse="' + idx + '">Close</a></div>' +
      '<div class="lw-collection-grid lw-fit__grid lw-fit-family__grid">' + renderOptions(items) + '</div></div>';
  }

  /* Fallback family when the search index doesn't know the product-line collection yet:
     brand + the part of the title before the first " - " (e.g. "BedRug Classic Bed Liner"). */
  function familyOf(it) {
    var t = String(it.title || '').replace(/^(Husky Liners\s+)+/i, 'Husky ').replace(/^RealTruck\s+/i, '');
    var head = t.split(/\s+-\s+/)[0].replace(/[™®]/g, '').trim();
    if (!head || head.length > 70 || head === t.replace(/[™®]/g, '').trim()) return null;
    return { url: '', title: head, key: (it.vendor || '') + '|' + head.toLowerCase() };
  }
  function renderVehicleSpecific(items, v, isLine) {
    /* Product-line page: one card per row/size, colors picked on the card. */
    if (isLine) return renderOptions(items);
    var lines = lineMap(), groups = [], byLine = {};
    items.forEach(function (it) {
      var ln = lineOf(it, lines) || familyOf(it);
      if (ln && !ln.key) ln.key = ln.url;
      if (ln) {
        if (!byLine[ln.key]) { byLine[ln.key] = { line: ln, items: [] }; groups.push(byLine[ln.key]); }
        byLine[ln.key].items.push(it);
      } else {
        groups.push({ line: null, items: [it] });
      }
    });
    /* Lines with a set rank (bed covers: most popular first) lead, in rank order; the rest keep search order. */
    var ranked = groups.some(function (g) { return g.line && g.line.rank; });
    if (ranked) {
      groups = groups.map(function (g, i) { return { g: g, i: i, r: (g.line && g.line.rank) || 9999 }; })
        .sort(function (a, b) { return a.r - b.r || a.i - b.i; })
        .map(function (x) { return x.g; });
    }
    return groups.map(function (g, i) {
      var html;
      if (!g.line || g.items.length < 2) html = productCard(g.items[0], 'Fits your truck');
      else if (g.line.url) html = lineCard(g.line, g.items, v);
      else html = familyCard(g.line, g.items, v, i) + familyPanel(g.line, g.items, v, i);
      /* cover type (soft-roll-up, hard-folding...) for the bed cover type tabs */
      if (ranked) html = html.replace('<article ', '<article data-cover-style="' + esc((g.line && g.line.style) || '') + '" ');
      return html;
    }).join('');
  }

  /* Put the best keyword matches first ("floor liner" should lead with floor liners, not bed liners):
     exact phrase first, then by which query words the title holds (earlier words count more). */
  function rankByQuery(items, q) {
    var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); };
    var stem = function (w) { return w.length > 3 ? w.replace(/(es|s)$/, '') : w; };
    var words = String(q).toLowerCase().split(/[^a-z0-9]+/).filter(function (w) { return w.length > 1; }).map(stem);
    var phrase = words.join('');
    function score(it) {
      var t = norm(it.title) + ' ' + norm(it.sku);
      if (words.length > 1 && t.indexOf(phrase) > -1) return 1000;
      var s = 0;
      words.forEach(function (w, i) { if (t.indexOf(w) > -1) s += words.length - i; });
      return s;
    }
    return items.map(function (it, i) { return { it: it, s: score(it), i: i }; })
      .sort(function (a, b) { return b.s - a.s || a.i - b.i; })
      .map(function (x) { return x.it; });
  }

  function setActive(on) {
    html.classList.toggle('lw-fit-on', !!on);
    html.classList.remove('lw-veh-pending');
    if (root) root.hidden = !on;
  }

  function run() {
    root = document.querySelector('[data-lw-fit]');
    if (!root) { html.classList.remove('lw-veh-pending'); return; }
    var v = saved();
    var params = new URLSearchParams(window.location.search);
    if (root.hasAttribute('data-query')) {
      placeSearchFit();
      /* page 2+, a chosen sort or filters mean the shopper is working the full result list */
      if (/[?&](page=([2-9]|\d{2,})|sort_by=|filter\.)/.test(window.location.search)) root.setAttribute('data-classic', 'true');
    }
    /* "See N options" from a category card lands here with ?fit=1: always show the fitted view */
    if (params.get('fit') === '1') { try { window.sessionStorage.removeItem(offKey()); } catch (x) {} }
    if (!v || params.get('view') === 'all' || root.getAttribute('data-classic') === 'true' || sessionOff()) { setActive(false); return; }

    var token = ++state.token;
    var coll = root.getAttribute('data-collection-id');
    var query = root.getAttribute('data-query') || '';
    var base = query ? { query: query } : { collection: coll };
    function find(o) { var x = {}, k; for (k in base) x[k] = base[k]; for (k in o) x[k] = o[k]; return search(x); }
    var catName = root.getAttribute('data-title') || 'products';
    var head = root.querySelector('[data-fit-head]');
    var vsGrid = root.querySelector('[data-fit-vs]');
    var uWrap = root.querySelector('[data-fit-universal]');
    var uGrid = root.querySelector('[data-fit-u-grid]');
    var more = root.querySelector('[data-fit-u-more]');
    var note = root.querySelector('[data-fit-note]');
    root.querySelectorAll('[data-fit-vehicle]').forEach(function (n) { n.textContent = label(v); });
    var what = query ? '&ldquo;' + esc(query) + '&rdquo; parts' : esc(catName.toLowerCase());
    var seeAll = query ? '<a href="#lw-browse" data-fit-off>' : '<a href="?view=all">';
    vsGrid.innerHTML = '<div class="lw-fit-loading">Finding ' + what + ' for your ' + esc(label(v)) + '&hellip;</div>';
    root.querySelectorAll('.lw-fit-more-note').forEach(function (n) { n.remove(); });
    uGrid.innerHTML = ''; uWrap.hidden = true; note.hidden = true;
    setActive(true);

    Promise.all([
      find({ size: 1 }),
      find({ vehicle: v, fitment: ['Vehicle Specific'], size: 120 }),
      find({ vehicle: v, fitment: ['Universal Fit'], size: 24 })
    ]).then(function (r) {
      if (token !== state.token) return;
      var all = facetCounts(r[0], 'FitmentType');
      var catVS = (all['Vehicle Specific'] || 0) + (all['No Fitment Data'] || 0);
      var vs = r[1].Items || [], vsTotal = r[1].TotalHits || 0;
      var u = r[2].Items || [], uTotal = r[2].TotalHits || 0;
      var total = r[0].TotalHits || 0;
      var isLine = root.getAttribute('data-line') === 'true';
      /* Mostly-universal categories (lighting, power, detailing...) keep the normal page.
         A keyword search that only matches universal parts (e.g. "light bar") keeps the normal results. */
      if (!total || !catVS || (!query && !isLine && catVS < Math.max(20, total * 0.2))) { setActive(false); return; }

      head.querySelector('[data-fit-count]').textContent = vsTotal;
      head.querySelectorAll('[data-fit-plural]').forEach(function (n) { n.textContent = vsTotal === 1 ? '' : n.getAttribute('data-fit-plural'); });
      colorGroups = [];
      if (vs.length) {
        if (query) vs = rankByQuery(vs, query);
        vsGrid.innerHTML = renderVehicleSpecific(vs, v, isLine);
      } else if (query) {
        vsGrid.innerHTML = '<div class="lw-fit-empty"><strong>Nothing matching &ldquo;' + esc(query) + '&rdquo; is listed for a ' + esc(label(v)) + ' yet.</strong>' +
          '<span>' + seeAll + 'See all ' + total + ' results for &ldquo;' + esc(query) + '&rdquo;</a>, try a different search, or call us at <a href="tel:2183080045">(218) 308-0045</a> — we can often source it.</span></div>';
      } else {
        vsGrid.innerHTML = '<div class="lw-fit-empty"><strong>No ' + esc(catName.toLowerCase()) + ' in our catalog are listed for a ' + esc(label(v)) + ' yet.</strong>' +
          '<span>Call us at <a href="tel:2183080045">(218) 308-0045</a> — we can often source it — or browse every product below.</span></div>';
      }
      if (vsTotal > vs.length) {
        vsGrid.insertAdjacentHTML('afterend', '<p class="lw-fit-more-note">Showing the first ' + vs.length + ' of ' + vsTotal + ' matches. ' + seeAll + 'Browse the full list</a>.</p>');
      }
      var nfd = all['No Fitment Data'] || 0;
      if (nfd > 0) {
        note.hidden = false;
        note.innerHTML = nfd + ' more ' + (nfd === 1 ? 'product' : 'products') + (query ? ' matching this search' : ' in this category') + ' don’t list vehicle fitment online yet. ' +
          (query ? '<a href="#lw-browse" data-fit-off>' : '<a href="?view=all" data-fit-off>') + 'See them all</a> or call us to confirm fit.';
      }
      if (uTotal) {
        uWrap.hidden = false;
        uWrap.querySelector('[data-fit-u-count]').textContent = uTotal;
        uGrid.innerHTML = u.map(function (it) { return productCard(it, 'Universal fit'); }).join('');
        state.uPage = 0;
        more.hidden = u.length >= uTotal;
        more.onclick = function () {
          state.uPage++;
          more.disabled = true;
          find({ vehicle: v, fitment: ['Universal Fit'], size: 24, page: state.uPage }).then(function (res) {
            uGrid.insertAdjacentHTML('beforeend', (res.Items || []).map(function (it) { return productCard(it, 'Universal fit'); }).join(''));
            more.disabled = false;
            more.hidden = uGrid.children.length >= uTotal || !(res.Items || []).length;
          }).catch(function () { more.disabled = false; });
        };
      }
      head.querySelectorAll('[data-fit-colors-note]').forEach(function (n) { n.hidden = !colorGroups.length; });
      if (window.LakewoodCoverSpecs) window.LakewoodCoverSpecs.refresh();
    }).catch(function () {
      if (token === state.token) setActive(false);
    });
  }

  function offKey() {
    var q = root && root.getAttribute('data-query');
    return 'lw:fit-off:' + location.pathname + (q ? '|' + q.toLowerCase() : '');
  }
  /* The search fit block is its own section below the results; move it (and the resume bar)
     up under the search box so it takes the place of the result list. */
  function placeSearchFit() {
    if (root.dataset.placed) return;
    root.dataset.placed = '1';
    var host = document.querySelector('.lw-search-next > .lw-container');
    if (!host) return;
    var after = host.querySelector('.lw-search-category-match') || host.querySelector('.lw-search-next__quick');
    var resume = root.parentNode && root.parentNode.querySelector('[data-fit-resume]');
    var inner = root.querySelector('.lw-container');
    if (inner) { while (inner.firstChild) root.insertBefore(inner.firstChild, inner); inner.remove(); }
    if (resume) resume.classList.remove('lw-container');
    var ref = after ? after.nextSibling : host.firstChild;
    host.insertBefore(root, ref);
    if (resume) host.insertBefore(resume, root.nextSibling);
  }
  function sessionOff() {
    try { return window.sessionStorage.getItem(offKey()) === '1'; } catch (e) { return false; }
  }

  /* Open or close a family card's in-place option panel. */
  function togglePanel(idx, open) {
    var panel = root.querySelector('[data-fit-panel="' + idx + '"]');
    var trigger = root.querySelector('[data-fit-expand="' + idx + '"]');
    if (!panel) return;
    panel.hidden = !open;
    if (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      var card = trigger.closest('.lw-fit-card');
      if (card) card.classList.toggle('is-open', open);
    }
    if (open) {
      if (window.LakewoodCoverSpecs) window.LakewoodCoverSpecs.refresh();
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else if (trigger) {
      trigger.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var sw = e.target.closest && e.target.closest('[data-fit-color]');
    if (!sw) return;
    e.preventDefault();
    selectColor(sw.closest('[data-fit-cg]'), Number(sw.getAttribute('data-fit-color')));
  });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-fit-color]');
    if (sw) {
      e.preventDefault();
      selectColor(sw.closest('[data-fit-cg]'), Number(sw.getAttribute('data-fit-color')));
      return;
    }
    var expand = e.target.closest && e.target.closest('[data-fit-expand]');
    if (expand && root) {
      e.preventDefault();
      var idx = expand.getAttribute('data-fit-expand');
      var panel = root.querySelector('[data-fit-panel="' + idx + '"]');
      togglePanel(idx, !!(panel && panel.hidden));
      return;
    }
    var collapse = e.target.closest && e.target.closest('[data-fit-collapse]');
    if (collapse && root) {
      e.preventDefault();
      togglePanel(collapse.getAttribute('data-fit-collapse'), false);
      return;
    }
    var off = e.target.closest && e.target.closest('[data-fit-off]');
    if (off) {
      e.preventDefault();
      try { window.sessionStorage.setItem(offKey(), '1'); } catch (x) {}
      setActive(false);
      var target = document.getElementById('lw-browse') || document.getElementById('MainContent');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var on = e.target.closest && e.target.closest('[data-fit-on]');
    if (on) {
      e.preventDefault();
      try { window.sessionStorage.removeItem(offKey()); } catch (x) {}
      run();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  /* Product-line card CTAs follow the saved truck */
  function lineCtas() {
    var v = saved();
    document.querySelectorAll('[data-pl-cta]').forEach(function (cta) {
      cta.innerHTML = (v ? 'See fit for ' + esc([v.year, v.make, v.model].join(' ')) : 'Select your truck') + ' <span aria-hidden="true">&rarr;</span>';
    });
    document.querySelectorAll('[data-fit-resume]').forEach(function (n) {
      n.hidden = !v;
      var t = n.querySelector('[data-fit-vehicle]');
      if (t) t.textContent = label(v);
    });
  }

  function boot() {
    lineCtas();
    run();
    whenCm(function () {
      var before = vstr(saved());
      sync();
      lastSeen = vstr(cmVehicle());
      watch();
      if (vstr(saved()) !== before) { lineCtas(); run(); }
    });
  }
  document.addEventListener('lakewood:vehiclechange', function () {
    lineCtas();
    try { window.sessionStorage.removeItem(offKey()); } catch (x) {}
    run();
  });

  /* ---------------- header search dropdown ----------------
     With a truck saved, swap the dropdown's product list for parts that fit it. */
  function pTerm(box) {
    var a = box.querySelector('.lw-predictive__all');
    if (!a) return '';
    try { return new URL(a.getAttribute('href'), location.href).searchParams.get('q') || ''; } catch (e) { return ''; }
  }
  function pItem(it) {
    return '<a class="lw-predictive__product" href="' + esc(it.url) + '" role="option">' +
      '<span class="lw-predictive__image">' + (it.image ? '<img loading="lazy" src="' + esc(img(it.image, 180)) + '" alt="">' : '') + '</span>' +
      '<span class="lw-predictive__copy"><small>' + esc(brandName(it.vendor)) + '</small><strong>' + esc(it.title) + '</strong><span>' + money(it.price) + '</span></span></a>';
  }
  function enhancePredictive(box) {
    var v = saved();
    if (!v || box.querySelector('[data-lw-pfit]')) return;
    var term = pTerm(box);
    if (!term || box.getAttribute('data-lw-pterm') === term + '|' + vstr(v)) return;
    box.setAttribute('data-lw-pterm', term + '|' + vstr(v));
    search({ query: term, vehicle: v, fitment: ['Vehicle Specific'], size: 48 }).then(function (res) {
      var items = rankByQuery(res.Items || [], term).slice(0, 5), total = res.TotalHits || 0;
      if (!items.length || pTerm(box) !== term || box.querySelector('[data-lw-pfit]')) return;
      box.querySelectorAll('.lw-predictive__heading').forEach(function (h) {
        if (/^\s*products\s*$/i.test(h.textContent)) {
          var list = h.nextElementSibling;
          if (list && list.classList.contains('lw-predictive__products')) list.remove();
          h.remove();
        }
      });
      var block = document.createElement('div');
      block.setAttribute('data-lw-pfit', '');
      block.innerHTML = '<div class="lw-predictive__heading">Fits your ' + esc(label(v)) + '</div>' +
        '<div class="lw-predictive__products">' + items.map(pItem).join('') + '</div>';
      var anchor = box.querySelector('.lw-predictive__heading') || box.querySelector('.lw-predictive__all');
      var wrap = box.querySelector('.lw-predictive') || box;
      if (anchor && anchor.parentNode === wrap) wrap.insertBefore(block, anchor);
      else wrap.appendChild(block);
      var all = box.querySelector('.lw-predictive__all');
      if (all) all.innerHTML = 'View all ' + total + ' &ldquo;' + esc(term) + '&rdquo; parts for your ' + esc(label(v)) + ' <span aria-hidden="true">&rarr;</span>';
    }).catch(function () { box.removeAttribute('data-lw-pterm'); });
  }
  function initPredictiveFit() {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('[data-predictive-search]').forEach(function (box) {
      if (box.dataset.lwPfitReady) return;
      box.dataset.lwPfitReady = '1';
      new MutationObserver(function () {
        if (!box.querySelector('[data-lw-pfit]')) box.removeAttribute('data-lw-pterm');
        enhancePredictive(box);
      }).observe(box, { childList: true });
    });
  }

  /* ---------------- product page: pick the color ----------------
     Floor liners and cargo liners are one product per color. On a product page, the other colors
     of the same version (same truck, same row) are offered as swatches that link across. */
  function initVersions() {
    var box = document.querySelector('[data-lw-versions]');
    if (!box) return;
    var lineId = box.getAttribute('data-line-id'), handle = box.getAttribute('data-handle');
    var title = box.getAttribute('data-title') || '', sku = box.getAttribute('data-sku') || '';
    var cs = colorSplit(specBits(title, sku));
    if (!lineId || !cs.color) return;
    var S = window.LakewoodCoverSpecs;
    var vt = S && S.parseTitle ? S.parseTitle(title).vehicle : '';
    var restKey = cs.rest.join('|').toLowerCase();
    function isMe(it) { return (sku && it.sku === sku) || (it.url && String(it.url).indexOf('/products/' + handle) > -1); }
    var v = saved();
    var first = v
      ? search({ collection: lineId, vehicle: v, fitment: ['Vehicle Specific'], size: 120 }).then(function (r) { var items = r.Items || []; return items.some(isMe) ? items : null; }).catch(function () { return null; })
      : Promise.resolve(null);
    first.then(function (items) {
      if (items) return items;
      if (!vt) return null;
      return search({ collection: lineId, query: vt, fitment: ['Vehicle Specific'], size: 120 }).then(function (r) {
        return (r.Items || []).filter(function (it) { return S.parseTitle(it.title).vehicle === vt; });
      });
    }).then(function (items) {
      if (!items) return;
      var seen = {}, list = [];
      items.forEach(function (it) {
        var c = colorSplit(specBits(it.title, it.sku));
        if (!c.color || c.rest.join('|').toLowerCase() !== restKey) return;
        var k = c.color.toLowerCase();
        if (seen[k] && !isMe(it)) return;
        if (seen[k]) list = list.filter(function (x) { return x.color.toLowerCase() !== k; });
        seen[k] = true;
        list.push({ color: c.color, it: it, me: isMe(it) });
      });
      if (!list.some(function (x) { return x.me; })) list.push({ color: cs.color, it: { url: location.pathname }, me: true });
      if (list.length < 2) return;
      box.innerHTML = '<div class="lw-pdp__versions-label">Color: <strong>' + esc(cs.color) + '</strong><small>' + list.length + ' colors for this truck</small></div>' +
        '<div class="lw-fit-swatches lw-pdp__swatches">' + list.map(function (x) {
          var hex = COLOR_HEX[x.color.toLowerCase()] || '#999';
          return '<a class="lw-fit-swatch' + (x.me ? ' is-selected' : '') + '" href="' + esc(x.me ? location.pathname : x.it.url) + '"' + (x.me ? ' aria-current="page"' : '') + '><i style="background:' + hex + '"></i>' + esc(x.color) + '</a>';
        }).join('') + '</div>';
      box.hidden = false;
    }).catch(function () {});
  }

  /* ---------------- product page: fit badge ----------------
     Turns the "Make sure it fits" notice into a yes/no for the shopper's saved truck. */
  function initFitBadge() {
    var box = document.querySelector('[data-lw-product-fitment]');
    if (!box || !box.hasAttribute('data-handle')) return;
    var tEl = box.querySelector('[data-lw-product-fitment-title]'), cEl = box.querySelector('[data-lw-product-fitment-copy]'), aEl = box.querySelector('a');
    var handle = box.getAttribute('data-handle') || '', sku = box.getAttribute('data-sku') || '';
    var universal = box.getAttribute('data-universal') === 'true';
    function set(cls, t, c, lt) {
      box.classList.remove('is-fit', 'is-nofit', 'is-unknown');
      if (cls) box.classList.add(cls);
      if (tEl) tEl.textContent = t;
      if (cEl) cEl.textContent = c;
      if (aEl && lt) aEl.innerHTML = esc(lt) + ' <span aria-hidden="true">→</span>';
    }
    function isMe(it) { return (sku && it.sku === sku) || (it.url && String(it.url).indexOf('/products/' + handle) > -1); }
    var v = saved();
    if (!v) { set('', 'Select your truck to confirm fit.', 'Pick your year, make and model once and every page shows what fits.', 'Select your truck'); return; }
    var lv = label(v);
    if (universal) { set('is-fit', 'Fits your ' + lv + '.', 'Universal part: not vehicle specific, works with any truck.', 'Change truck'); return; }
    var q = sku || handle.replace(/-/g, ' ');
    search({ query: q, vehicle: v, size: 24 }).then(function (r) {
      if ((r.Items || []).some(isMe)) {
        set('is-fit', 'Fits your ' + lv + '.', 'This part is listed for your truck. If the title names a bed length or cab, double-check it matches yours.', 'Change truck');
        return null;
      }
      return search({ query: q, size: 24 });
    }).then(function (r2) {
      if (!r2) return;
      if ((r2.Items || []).some(isMe)) {
        set('is-nofit', 'Not listed for your ' + lv + '.', 'This part isn’t shown as fitting your truck. See the versions that do, or call us and we’ll double-check.', 'Shop parts for my truck');
      } else {
        set('is-unknown', 'Confirm fit for your ' + lv + '.', 'We couldn’t check this part automatically. Call us before ordering and we’ll verify it.', 'Change truck');
      }
    }).catch(function () {});
  }

  function start() { initPredictiveFit(); initVersions(); initFitBadge(); boot(); }
  window.__lwFit = { specBits: specBits, colorSplit: colorSplit, positionLabel: positionLabel, groupOptions: groupOptions, renderOptions: renderOptions, lineSummary: lineSummary };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
